import styles from './CustomizeCollections.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import { TextInput, TextInputValue } from 'src/components/text-input/TextInput';
import { useCallback, useEffect, useState } from 'react';
import Spinner from '@src/components/spinner/Spinner';
import { useUpdateCollectionMutation } from '@src/api/graphql-codegen';
import { useToast } from '@src/hooks';

type Props = {
  open: boolean;
  collection?: any;
  onClose: () => void;
};

function EditCollectionNameModal(props: Props) {
  const { open, collection,  onClose } = props;
  const [ name, setName ] = useState(collection?.name ?? "")
  const [ error, setError ] = useState("")
  const { successToast } = useToast();

  const [updateCollection, {loading}] = useUpdateCollectionMutation({
    onCompleted(data, clientOptions) {
        if (data.updateCollection) {
          successToast('Updated Collection Name Successfully!')
        }
    },
    onError(error) {
      setError(error.message)
    }
  })
  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const onPageLoad = () => {
      const item = document.getElementById("name")
      if (item) {
        item.focus();
      }
    };
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      return () => window.removeEventListener('load', onPageLoad);
    }

  }, [])

  const handleChange = (value: TextInputValue) => {
    setName(value.toString())
    setError('')
  }
  const handleUpdateNew = useCallback(() => {
    updateCollection({
      variables: {
        input: {
          id: collection?.id ?? '',
          name,
          grade: collection?.grade ?? '',
          country: collection?.country ?? '',
        }
      }
    });
  }, [collection, name, updateCollection])

  return (
    <Modal open={open} onClose={handleClose} className={styles.editModal}>
      <div>
        <div className={styles.editTitle}>{'Edit Collection'}</div>
        <div className={styles.editContent}>
          <TextInput hasError={error!==''} subTitle={error} id="name" placeholder={'Collection Name'} value={name} label={'Collection Name'} onChange={handleChange} />
          <div className={styles.editAction}>
            <Button disabled={false} size="small" leftIcon={loading ? <Spinner width={20} height={20} /> : undefined} className={styles.cancelButton} onClick={handleClose} label={'Cancel'}/>
            <Button disabled={loading || !name} size="small" leftIcon={loading ? <Spinner width={20} height={20} /> : undefined} className={styles.renameButton} onClick={handleUpdateNew} label={'SAVE'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default EditCollectionNameModal;
